module.exports = __webpack_public_path__ + "img/logo.2ae49692.jpg";